(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/member-accordion.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/member-accordion.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactAccordio = svs.ui.ReactAccordion,
  Accordion = _svs$ui$ReactAccordio.Accordion,
  AccordionItem = _svs$ui$ReactAccordio.AccordionItem,
  AccordionSummary = _svs$ui$ReactAccordio.AccordionSummary,
  AccordionDetails = _svs$ui$ReactAccordio.AccordionDetails;
const Button = svs.ui.ReactButton;
const memberStates = svs.arena.constants.memberStates;
const InlineErrorMessage = svs.components.tb_ui_react.inlineMessage.InlineErrorMessage;
const getActiveMembers = svs.arena.pages.teams.helpers.activeMembers;
const _svs$arena$store$team = svs.arena.store.teams.actions,
  fetchTeamDetails = _svs$arena$store$team.fetchTeamDetails,
  fetchTeamInviteId = _svs$arena$store$team.fetchTeamInviteId,
  createTeamInviteId = _svs$arena$store$team.createTeamInviteId;
const _svs$arena$pages$team = svs.arena.pages.teams.teamMembers,
  ActiveMember = _svs$arena$pages$team.ActiveMember,
  InactiveMember = _svs$arena$pages$team.InactiveMember;
const _svs$arena$pages$team2 = svs.arena.pages.teams.components,
  TeamEmail = _svs$arena$pages$team2.TeamEmail,
  TeamInviteLink = _svs$arena$pages$team2.TeamInviteLink,
  AllAdminCheckbox = _svs$arena$pages$team2.AllAdminCheckbox;
const memberOrMembers = amount => amount > 1 ? 'medlemmar' : 'medlem';

const ExpandedListener = _ref => {
  let expanded = _ref.expanded,
    setIsExpanded = _ref.setIsExpanded;
  React.useEffect(() => {
    setIsExpanded(expanded);
  }, [setIsExpanded, expanded]);
  return null;
};
const MemberAccordion = _ref2 => {
  var _myTeamDetails$member, _myTeamDetails$member2;
  let team = _ref2.team,
    teamId = _ref2.teamId;
  const dispatch = ReactRedux.useDispatch();
  const inviteIds = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.inviteIds;
  }) || [];
  const allTeamDetails = ReactRedux.useSelector(state => {
    var _state$teams2;
    return (_state$teams2 = state.teams) === null || _state$teams2 === void 0 ? void 0 : _state$teams2.teamDetails;
  }) || [];
  const myTeamDetails = allTeamDetails.find(item => item.syndicateId === teamId);
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isError = _React$useState2[0],
    setIsError = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isShowTeamEmail = _React$useState4[0],
    setIsShowTeamEmail = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isExpanded = _React$useState6[0],
    setIsExpanded = _React$useState6[1];
  const _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isExpandedTrack = _React$useState8[0],
    setIsExpandedTrack = _React$useState8[1];
  const _ref3 = team || {},
    syndicateName = _ref3.syndicateName,
    isLeader = _ref3.isLeader,
    adminManagedWagers = _ref3.adminManagedWagers;
  const activeMembers = getActiveMembers(myTeamDetails === null || myTeamDetails === void 0 ? void 0 : myTeamDetails.members);
  const inactiveMembers = myTeamDetails === null || myTeamDetails === void 0 || (_myTeamDetails$member = myTeamDetails.members) === null || _myTeamDetails$member === void 0 ? void 0 : _myTeamDetails$member.filter(_ref4 => {
    let memberState = _ref4.memberState;
    return memberState === memberStates.INACTIVE;
  });
  const inactiveMemberCount = (inactiveMembers === null || inactiveMembers === void 0 ? void 0 : inactiveMembers.length) || (team === null || team === void 0 ? void 0 : team.fullMemberCount) - (team === null || team === void 0 ? void 0 : team.activeMemberCount);
  const hasInactiveMembers = inactiveMemberCount > 0;
  const membersNoBalance = myTeamDetails === null || myTeamDetails === void 0 || (_myTeamDetails$member2 = myTeamDetails.members) === null || _myTeamDetails$member2 === void 0 ? void 0 : _myTeamDetails$member2.filter(_ref5 => {
    let memberBalance = _ref5.memberBalance,
      memberState = _ref5.memberState;
    return parseInt(memberBalance, 10) === 0 && memberState === memberStates.ACTIVE;
  }).length;

  React.useEffect(() => {
    if (isExpanded && isLeader) {
      svs.arena.logger.debug('MemberAccordion, useEffect...fetchInviteLink for team...');
      const inviteLink = inviteIds.find(item => item.teamId === teamId);
      if (inviteLink) {
        svs.arena.logger.debug('*** InviteLink in useEffect: found item teamId, link ', teamId, inviteLink);
        const linkDate = new Date(inviteLink.validTo).valueOf();
        const now = new Date().valueOf();
        const isOk = linkDate - now > 24 * 60 * 60 * 1000; 

        if (!isOk) {
          svs.arena.logger.debug('*** InviteLink in useEffect: not valid, creating new link', linkDate, now, isOk);
          dispatch(createTeamInviteId({
            teamId
          }));
        }
      } else {
        svs.arena.logger.debug('*** InviteLink in useEffect: did NOT found link, try to get it...');
        dispatch(fetchTeamInviteId(teamId));
      }
    }
  }, [dispatch, inviteIds, isExpanded, isLeader, teamId]);
  const trackClick = () => {
    setIsExpandedTrack(current => !current);
    const track = {
      category: 'spela-tillsammans',
      action: 'members',
      opt_label: isExpandedTrack ? 'card_click' : 'card_closed'
    };
    svs.components.analytics.trackEvent(track);
  };
  React.useEffect(() => {
    const fetchTeamDetailsAsync = async () => {
      const fetchData = await dispatch(fetchTeamDetails(teamId));
      if (RTK.isRejected(fetchData)) {
        return setIsError(true);
      }
      setIsError(false);
    };
    if (isExpanded) {
      svs.arena.logger.debug('MemberAccordion, useEffect...fetchteamDetails for team...');
      const teamData = allTeamDetails.find(item => item.syndicateId === teamId);
      if (teamData) {
        svs.arena.logger.debug('*** teamData in useEffect: found item for team ', teamId, teamData);
      } else {
        svs.arena.logger.debug('*** teamData in useEffect: did NOT found teamData, try to get it...');
        fetchTeamDetailsAsync();
      }
    }
  }, [dispatch, allTeamDetails, isExpanded, teamId]);
  const memberAccordionDescription = () => {
    let extraText = '';
    if (membersNoBalance && hasInactiveMembers) {
      extraText = ", varav ".concat(inactiveMemberCount, " vilande och ").concat(membersNoBalance, " utan saldo");
    } else if (membersNoBalance) {
      extraText = ", varav ".concat(membersNoBalance, " utan saldo");
    } else if (hasInactiveMembers) {
      extraText = ", varav ".concat(inactiveMemberCount, " vilande");
    }
    return "".concat(team === null || team === void 0 ? void 0 : team.fullMemberCount, " ").concat(memberOrMembers(team === null || team === void 0 ? void 0 : team.fullMemberCount)).concat(extraText);
  };
  const onShowEmail = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: 'show_email_field'
    };
    svs.components.analytics.trackEvent(track);
    setIsShowTeamEmail(true);
  };
  return React.createElement(Accordion, {
    className: "margin-top-1-override",
    isFlat: true
  }, React.createElement(AccordionItem, {
    onChange: trackClick
  }, React.createElement(ExpandedListener, {
    setIsExpanded: expanded => setIsExpanded(!expanded)
  }), React.createElement(AccordionSummary, {
    className: "member-accordion"
  }, React.createElement("div", null, React.createElement("h4", {
    className: "accordion-h4 override"
  }, React.createElement("span", {
    className: "f-medium accordion-h4 override"
  }, "Medlemmar")), React.createElement("span", {
    className: "accordion-span override"
  }, memberAccordionDescription()))), React.createElement(AccordionDetails, null, isExpanded && React.createElement("div", null), isError && React.createElement(InlineErrorMessage, {
    actions: [{
      handleClick: () => dispatch(fetchTeamDetails(teamId)),
      text: 'Försök igen'
    }],
    header: "Tillf\xE4lligt fel!",
    icon: "exclamation-sign"
  }, "N\xE5gonting gick fel n\xE4r medlemmar skulle visas upp. F\xF6rs\xF6k igen om en stund."), !isError && React.createElement(React.Fragment, null, React.createElement("div", null, isLeader && React.createElement(AllAdminCheckbox, {
    isAdminManagedWagers: adminManagedWagers,
    teamId: teamId
  }), activeMembers === null || activeMembers === void 0 ? void 0 : activeMembers.map(member => React.createElement(ActiveMember, {
    isLeader: isLeader,
    key: member.customerId,
    member: member,
    teamId: teamId,
    teamName: syndicateName
  }))), !(team !== null && team !== void 0 && team.isInactive) && (inactiveMembers === null || inactiveMembers === void 0 ? void 0 : inactiveMembers.length) > 0 && React.createElement(React.Fragment, null, React.createElement("h4", {
    className: "h4 margin-top-2 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, " Vilande ")), inactiveMembers === null || inactiveMembers === void 0 ? void 0 : inactiveMembers.map(member => React.createElement(InactiveMember, {
    isLeader: isLeader,
    key: member.customerId,
    member: member,
    teamId: teamId,
    teamName: syndicateName
  }))), isShowTeamEmail && React.createElement("div", {
    className: "margin-top-3"
  }, React.createElement(TeamEmail, {
    activeMembers: activeMembers || [],
    inactiveMembers: inactiveMembers,
    onHide: () => setIsShowTeamEmail(false),
    teamId: teamId
  })), !isShowTeamEmail && (team === null || team === void 0 ? void 0 : team.fullMemberCount) > 1 && React.createElement("div", {
    className: "margin-top-3"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: onShowEmail,
    size: 200,
    transparent: true
  }, "Skicka e-post till laget")), isLeader && React.createElement(TeamInviteLink, {
    fullMemberCount: team === null || team === void 0 ? void 0 : team.fullMemberCount,
    isExpanded: isExpanded,
    teamId: teamId
  })))));
};
svs.arena.pages.teams.components.MemberAccordion = MemberAccordion;

 })(window);